module.exports = __webpack_public_path__ + "media/packs/images/state/emptyreturn-28b09ff3ec29fab04c9c5df6473f4227.svg";